import $ from "jquery";
import moment from "moment";
import { u_ } from "@pressmedia/webappbase";
import addEventList from "./addEventList";
import addKeyPrefixToObject from "./addKeyPrefixToObject";

export default {
	addEventList,
	
	renderCalendar(ym, holidays, events) {
		const now = moment();
		const dayFirst = moment(
			`${( ym && u_.isString(ym) ) ? ym : now.format("YYYY-MM")}-01`
		);
		
		if( !dayFirst.isValid() ) {
			throw new TypeError("VuwMinimalCalendarTable._renderCalendar() ... arguments[0] is illegal format.");
		}
		
		Array.isArray(holidays) || (holidays = []);
		Array.isArray(events) || (events = []);
		
		// weekdays length (=7)
		const daysLen = this.weekdaysTexts.length;
		
		// weekdaysIndex of first day
		const daysDayFirst = (dayFirst.days() - this.firstDayOfWeek + daysLen) % daysLen;
		const curDay = dayFirst.clone().subtract(daysDayFirst, "days");
		
		const $tbody = this.createTbody();
		let weekPos = 0;
		while( !curDay.isAfter(dayFirst, "month") ) {
			const $week = this.$weekTemplate.clone();
			
			for(let i = 0; i < daysLen; i++) {
				(i === daysDayFirst) && (weekPos++);
				
				const $day = $("<div/>").append(
					$("<span/>").addClass(this.classPrefix + "day-text").text( curDay.format("D") )
				);
				
				const data = {
					date: curDay.format("YYYY-MM-DD"),
					weekday: this.weekdaysKeys[i]
				};
				
				curDay.isSame(dayFirst, "month") || (data.outside = 1);
				
				const classList = [`${this.classPrefix}day`];
				const daysIdx = (i + this.firstDayOfWeek) % daysLen;
				
				// check holiday
				if(	Array.isArray(holidays[weekPos]) &&
						Array.isArray(holidays[weekPos][daysIdx])
				) {
					classList.push(`${this.classPrefix}holiday`);
					data.holiday = holidays[weekPos][daysIdx][0].name || "";
				}
				
				// check events
				if( Array.isArray(events[weekPos]) && Array.isArray(events[weekPos][daysIdx]) ) {
					classList.push(`${this.classPrefix}has-events`);
					data.events = events[weekPos][daysIdx];
					this.addEventList($day, data.events, curDay);
				}
				
				// check today
				curDay.isSame(now, "day") && classList.push(`${this.classPrefix}today`);
				
				// append to week
				const attr = addKeyPrefixToObject({ ...data }, "data-");
				$day.addClass( classList.join(" ") ).attr(attr).appendTo($week);
				
				// call callback
				u_.isFunction(this.onRenderDay) && this.onRenderDay($day, data, data.events);
				
				// next day
				curDay.add(1, "days");
			}
			
			$tbody.append($week);
		}
		
		this.$tbody.replaceWith($tbody);
		this.$tbody = $tbody;
		
		return this;
	}
}
